import React from 'react';

import RemoteAutocomplete from './RemoteAutocomplete';

const buildOrderUrl = (search) => {
  const params = new URLSearchParams({ limit: '20' });
  if (search) {
    params.set('q', /^\d+$/.test(search) ? `gid:${search}` : search);
  } else {
    params.set('status', 'active');
  }
  return `/jobs/groups?${params.toString()}`;
};

const OrderIdAutocomplete = ({ name, value, onChange, sx }) => (
  <RemoteAutocomplete
    buildUrl={buildOrderUrl}
    getOptionKey={(option) => option.gid}
    getOptionLabel={(option) => String(option.gid)}
    getOptionValue={(option) => option.gid}
    hydrateSelectedOption
    name={name}
    onChange={onChange}
    renderOptionLabel={(option) => `${option.gid} - ${option.name}`}
    sx={sx}
    value={value}
  />
);

export default OrderIdAutocomplete;
